import React, { FC, useEffect } from 'react';

import Modal from '@rover/kibble/official-patterns/Modal';
import TextWithSingleInlineLink from '@rover/kibble/official-patterns/TextWithSingleInlineLink';
import { isMobileBrowser } from '@rover/rsdk/src/modules/Network/userAgent';
import type { PriceTransparencyLevel } from '@rover/types/src/PriceTransparencyLevel';
import emitMetric from '@rover/utilities/emitMetric';
import { getIsPriceTransparencyFull } from '@rover/utilities/priceTransparency';

import {
  EXPLANATION_MODAL_BUTTON_TEXT,
  EXPLANATION_MODAL_HEADER,
  EXPLANATION_MODAL_PARAGRAPH_WITH_LINK,
  URL,
} from './constants';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  priceTransparencyLevel: PriceTransparencyLevel;
  bookingPercentageFee: string;
};

/**
 * A similar modal is found in
 * reactNativeApp/src/pages/search/components/sheets/FeeExplanationSheet.tsx.
 *
 * Please ensure any changes to this file are reflected there.
 */

const FeeExplanationModal: FC<Props> = ({
  isOpen,
  onClose,
  priceTransparencyLevel,
  bookingPercentageFee,
}) => {
  const source = isMobileBrowser() ? 'mobile_web' : 'web';
  const isPtFull = getIsPriceTransparencyFull(priceTransparencyLevel);

  useEffect(() => {
    if (isOpen) {
      emitMetric('how-pricing-works-modal-viewed', { source });
    }
  }, [isOpen, source]);

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      headerText={EXPLANATION_MODAL_HEADER()}
      submitButtonText={EXPLANATION_MODAL_BUTTON_TEXT()}
      onClickSubmit={onClose}
      showCloseIcon
    >
      <TextWithSingleInlineLink
        paragraphText={EXPLANATION_MODAL_PARAGRAPH_WITH_LINK(isPtFull, bookingPercentageFee)}
        href={URL()}
        target="_blank"
      />
    </Modal>
  );
};

export default FeeExplanationModal;
